module.exports = __webpack_public_path__ + "static/CircularStd-Bold-03e7ee16210905484b09316e8298d712.woff";